// extracted by mini-css-extract-plugin
export default {"flexChild":"VendingDetail_flexChild__NacqK","table":"VendingDetail_table__tYKQk"};